module.exports = __webpack_public_path__ + "img/ecran1_6.17942ca3.png";